import { ICON_HEIGHT_20, IconWithTooltip } from '../../../Icon'
import { BirdviewInfoTooltipText } from '../../BirdviewInfoTooltipText'
import { QA_NAME_DASHBOARD_BIRDVIEW_CARD_INFO } from '../../DashboardBirdview.constants.qa'

import InfoIcon from '../../../../icons/info.svg'

function BirdviewCardInfo({ className, info, title }) {
  return (
    <IconWithTooltip
      isTooltipOpenOnClick
      Icon={InfoIcon}
      className={className}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_CARD_INFO}
      size={ICON_HEIGHT_20}
      tooltip={<BirdviewInfoTooltipText info={info} title={title} />}
    />
  )
}

export default BirdviewCardInfo
